import * as React from "react";
import { List, Datagrid, Edit, SimpleForm, TextField, EditButton, TextInput, required, NumberInput, useTranslate } from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";

// Entity
const entity = "systemParameters";
const entityTR = "parametre";

export const SystemParameterList = (props) => {
    const translate = useTranslate();
    return (
        <List {...props} empty={<EmptyList entity={entity} entityTR={entityTR} />} exporter={false} title={translate('systemParameters.title', { _: 'Sistem Parametreleri' })} filter={{ id: 'system' }}>
            <Datagrid>
                <TextField source="id" label={"ID"} />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const SystemParameterEdit = (props) => {
    const translate = useTranslate();
    return (
        <Edit title={translate('systemParameters.edit_title', { _: 'Sistem Parametrelerini Düzenle' })} {...props}>
            <SimpleForm>

                <div style={{ display: 'none' }}>
                    <TextInput source="id" label={"ID"} disabled />
                </div>

                <h3>{translate('systemParameters.system_settings', { _: 'Sistem Ayarları' })}</h3>
                <NumberInput source="settings.adminPhone" label={translate('systemParameters.admin_phone', { _: 'Admin Telefon Numarası' })} fullWidth validate={required()} />

                <h3>{translate('systemParameters.variables', { _: 'Değişkenler' })}</h3>
                <NumberInput source="variables.defaultServiceFee" label={translate('systemParameters.default_service_fee', { _: 'Varsayılan Hizmet Ücreti' })} fullWidth validate={required()} />
                <NumberInput source="variables.defaultCommissionFee" label={translate('systemParameters.default_commission_fee', { _: 'Varsayılan Komisyon Ücreti' })} fullWidth validate={required()} />

            </SimpleForm>
        </Edit>
    );
};
